import { render, staticRenderFns } from "./EmailBuilder.vue?vue&type=template&id=65334ec2&"
import script from "./EmailBuilder.vue?vue&type=script&lang=js&"
export * from "./EmailBuilder.vue?vue&type=script&lang=js&"
import style0 from "./EmailBuilder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports